import { __assign, __rest } from "tslib";
import React from "react";
import PropTypes from "prop-types";
import { View, Text } from "react-native";
import styles from "./PnmacHeader.styles";
import { withPnmacContext } from "../Context";
var PnmacHeader = function (_a) {
  var containerStyles = _a.containerStyles,
    theme = _a.theme,
    rest = __rest(_a, ["containerStyles", "theme"]);
  return /*#__PURE__*/React.createElement(View, {
    testID: "header"
  }, /*#__PURE__*/React.createElement(View, {
    style: __assign(__assign({}, styles.containerStyles(theme)), containerStyles)
  }, rest.children));
};
PnmacHeader.propTypes = {
  containerStyles: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string])
};
export default withPnmacContext(PnmacHeader);